import styled from "styled-components";

export const CardHolderDiv = styled.ul`
  --cardWidth: 250px;
  --gap: 25px;
  list-style-type: none;
  margin: 0;
  padding: 0;
  /* padding: var(--insidePadding); */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* background-color: var(--background); */
  & .my-masonry-grid {
    display: -webkit-box; /* Not needed if autoprefixing */
    display: -ms-flexbox; /* Not needed if autoprefixing */
    display: flex;
    margin-left: calc(0px - var(--gap)); /* gutter size offset */
    margin-right: calc(var(--gap) / 2px);
    width: auto;
  }
  & .my-masonry-grid_column {
    margin-left: var(--gap); /* gutter size */
    background-clip: padding-box;
    width: var(--cardWidth) !important;
  }

  & .my-masonry-grid_column > li {
    margin-bottom: var(--gap);
  }
`;

export const SearchFieldBox = styled.div`
  --gap: 25px;
  background-color: var(--white);
  padding: var(--gap);
  margin-bottom: var(--gap);
  width: 100%;
  display: flex;
  justify-content: center;
  & label {
    font-size: 24px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    width: 100%;
    & input {
      margin-left: 10px;
      font-size: 24px;
      padding: 5px 10px;
      color: var(--text);
      border: 1px solid rgba(0, 0, 0, 0.1);
      font-family: var(--baseFont);
      flex: 2;
    }
  }
  @media (max-width: 767px) {
    & label {
      flex-direction: column;
    }
  }
`;
